module.exports = __webpack_public_path__ + "img/medivac.fe8f0bda.svg";